<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <div style="display: flex; align-items: center">
          <Breadcrumb>
            <BreadcrumbItem>参展</BreadcrumbItem>
            <BreadcrumbItem>会刊提交</BreadcrumbItem>
          </Breadcrumb>
          <!-- 2026-08-20 修改：会刊截止时间改为 10月20日 23:59（原代码注释保留） -->
          <!-- <p v-if="exhibition.id == 'ec6c5271-2bdd-48c7-9984-26ef50d21f4f'" style="margin-left: 20px; font-size: 20px; color: red">
            2026年6月30日截止
          </p>
          <p v-else style="margin-left: 20px; font-size: 20px; color: red">
            2026年3月8日晚17点截止
          </p> -->
          <p v-if="exhibition.id == 'ec6c5271-2bdd-48c7-9984-26ef50d21f4f'" style="margin-left: 20px; font-size: 20px; color: red">
            9月20日 23:59 截止
          </p>
          <p v-else style="margin-left: 20px; font-size: 20px; color: red">
            9月20日 23:59 截止
          </p>
        </div>

        <div class="header-tool-title">{{ exhibition.name }}</div>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow">加载中...</Spin>


    <div class="catalogue-content">
      <div class="catalogue-tip" v-if="catalogueDownInfo && editStatus">
        您于{{
          catalogueDownInfo.changeTime | moment("YYYY/MM/DD HH:mm:ss")
        }}
        提交的修改，尚未审核
        <!-- <span v-if="catalogueDownInfo.status === 1">审核通过</span> <span v-if="catalogueDownInfo.status === -1">审核未通过</span> -->
        <span
          @click="$router.push('/exhibition/index/exinfo/catalogue-alter')"
          class="txt"
          >查看我的修改</span
        >
      </div>
      <div style="display: flex">
        <div class="catalogue-content-l">
          <div class="catalogue-content-r">
            <!-- <Button type="primary" style="width:120px;margin-left:20px;" @click="copyInfo">复制公司信息</Button> -->
            <Form
              label-position="right"
              :label-width="200"
              @submit.native.prevent
            >
              <FormItem label="Logo：" prop="logo" style="margin-bottom: 0">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div
                      class="my-upload-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                      style="
                        width: 150px;
                        height: 150px;
                        line-height: 150px;
                        border: 1px solid #bfbfbf;
                      "
                    >
                      <template v-if="item.status === 'finished'">
                        <img
                          :src="item.url"
                          style="width: 150px; height: 150px"
                          v-if="item.url"
                        />
                        <img
                          src="@/assets/img/empty.png"
                          style="width: 150px; height: 150px"
                          v-else
                        />
                        <div class="my-upload-list-cover">
                          <Icon
                            type="ios-eye-outline"
                            @click.native="handleView(item.url)"
                          ></Icon>
                        </div>
                      </template>
                      <template v-else>
                        <Spin
                          v-if="item.showProgress"
                          style="width: 150px; height: 150px"
                        >
                          <Icon
                            type="ios-loading"
                            size="20"
                            class="demo-spin-icon-load"
                          ></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div
                    class="my-upload-list"
                    style="
                      width: 150px;
                      height: 150px;
                      line-height: 150px;
                      border: 1px solid #bfbfbf;
                    "
                    v-else
                  >
                    <img
                      src="@assets/img/empty.png"
                      style="width: 150px; height: 150px"
                    />
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img
                        v-if="uploadList && uploadList[0] && uploadList[0].url"
                        :src="uploadList[0].url"
                        style="width: 40px; height: 40px"
                      />
                      <!-- <div v-else style="width:40px;height:40px;border:1px solid #bfbfbf;"></div> -->
                      <img v-else src="@assets/img/empty.png" />
                      <p>图片尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img
                        :src="uploadList[0].url"
                        v-if="uploadList && uploadList[0] && uploadList[0].url"
                        style="width: 30px; height: 30px"
                      />
                      <!-- <div v-else style="width:30px;height:30px;border:1px solid #bfbfbf;"></div> -->
                      <img v-else src="@assets/img/empty.png" />
                      <p>图片尺寸：120*120px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img
                        :src="uploadList[0].url"
                        v-if="uploadList && uploadList[0] && uploadList[0].url"
                        style="width: 20px; height: 20px"
                      />
                      <!-- <div v-else style="width:20px;height:20px;border:1px solid #bfbfbf;"></div> -->
                      <img v-else src="@assets/img/empty.png" />
                      <p>图片尺寸：30*30px</p>
                    </div>
                  </div>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  style="display: inline-block; position: relative"
                >
                  <Button icon="ios-cloud-upload-outline" v-if="!editStatus"
                    >更改Logo</Button
                  >
                  <!-- 蒙版 -->
                  <div
                    class="mask"
                    style="
                      position: absolute;
                      opacity: 0;
                      width: 115px;
                      height: 34px;
                      left: 0;
                      top: 0;
                    "
                    @click.stop="selectType"
                    v-if="!editStatus"
                  ></div>
                </Upload>
                <p class="upload-p" v-if="!editStatus">
                  (图片要求：2M以下的jpg或png，建议尺寸120*120px)
                </p>
              </FormItem>
            </Form>
          </div>
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="200"
            @submit.native.prevent
          >
            <FormItem label="公司名称：">
              <Input type="text" v-model="formInline.name" disabled />
            </FormItem>
            <FormItem label="展位号：">
              <Input type="text" v-model="formInline.exHall" disabled />
            </FormItem>
            <FormItem label="公司英文名：" prop="enName">
              <Input
                type="text"
                v-model="formInline.enName"
                placeholder="请输入公司英文名"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
            </FormItem>
            <FormItem label="国家/地区：" required style="margin-bottom: 0">
              <Row type="flex" justify="space-between">
                <Col span="7">
                  <FormItem prop="country">
                    <Select
                      v-model="formInline.country"
                      placeholder="请选择国家"
                      @on-change="changeCountry"
                      filterable
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    >
                      <Option
                        v-for="(item, index) in countryList"
                        :key="item.name"
                        :value="item.name"
                        @click.native="changeCountryValue(item)"
                        >{{ item.name }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
                <Col span="7" v-if="formInline.country === '中国'">
                  <FormItem prop="province">
                    <Select
                      v-model="formInline.province"
                      placeholder="请选择省份"
                      @on-change="changeProvince"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    >
                      <Option
                        v-for="(item, index) in provinceArr"
                        :key="'province-' + item.shortname"
                        :value="item.shortname"
                        @click.native="changeProvinceValue(item)"
                        >{{ item.shortname }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
                <Col span="7" v-if="formInline.country === '中国'">
                  <FormItem prop="city">
                    <Select
                      v-model="formInline.city"
                      placeholder="请选择城市"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    >
                      <Option
                        v-for="(item, index) in citiesArr"
                        :key="'city-' + item.shortname"
                        :value="item.shortname"
                        @click.native="changeCity(item)"
                        >{{ item.shortname }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="地址：" required style="margin-bottom: 0">
              <Row type="flex" justify="space-between">
                <Col span="16">
                  <FormItem prop="address">
                    <Input
                      type="text"
                      v-model="formInline.address"
                      placeholder="填写街道楼牌号"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
                <Col span="7">
                  <FormItem prop="mail">
                    <Input
                      type="text"
                      v-model="formInline.mail"
                      placeholder="请输入邮政编码"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="英文地址：" prop="enAddress">
              <Input
                type="text"
                v-model="formInline.enAddress"
                placeholder="请输入英文地址"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
            </FormItem>
            <!-- <FormItem label="企业类型：" prop="type">
              <Select
                v-model="formInline.type"
                placeholder="请选择企业类型"
                :disabled="catalogueDownInfo && editStatus?true:false"
              >
                <Option
                  v-for="(item, index) in exTypeList"
                  :key="item.name"
                  :value="item.name"
                >{{ item.name }}</Option>
              </Select>
            </FormItem> -->
            <!-- <FormItem label="人员规模：" prop="staff">
              <Select
                v-model="formInline.staff"
                placeholder="请选择企业类型"
                :disabled="catalogueDownInfo && editStatus?true:false"
              >
                <Option
                  v-for="(item, index) in staffArr"
                  :key="item.value"
                  :value="item.value"
                >{{ item.value }}</Option>
              </Select>
            </FormItem> -->
            <!-- <FormItem label="年销售额：" prop="sales">
              <Input
                type="text"
                v-model="formInline.sales"
                placeholder="请输入年销售额"
                :disabled="catalogueDownInfo && editStatus?true:false"
              />
            </FormItem> -->
            <FormItem label="公司网址：">
              <Input
                type="text"
                v-model="formInline.url"
                placeholder="请输入公司网址"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
            </FormItem>
            <FormItem label="公司邮箱：" prop="email">
              <Input
                type="text"
                v-model="formInline.email"
                placeholder="请输入公司邮箱"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
            </FormItem>

            <FormItem label="联系人姓名：" required style="margin-bottom: 0">
              <Row>
                <Col span="3" style="padding: 0">
                  <FormItem prop="LinkFirstName">
                    <Input
                      type="text"
                      v-model="formInline.LinkFirstName"
                      placeholder="姓氏"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
                <Col span="5" style="margin-left: 8px">
                  <FormItem prop="LinkLastName">
                    <Input
                      type="text"
                      v-model="formInline.LinkLastName"
                      placeholder="名字"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
              </Row>
            </FormItem>

            <FormItem label="联系人手机：" prop="LinkMob">
              <Input
                type="text"
                v-model="formInline.LinkMob"
                placeholder="请输入联系人手机"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
            </FormItem>

            <FormItem label="电话：" :required="true">
              <Row>
                <Col span="3" style="padding: 0">
                  <FormItem prop="LinkTel1">
                    <Input
                      type="text"
                      v-model="formInline.LinkTel1"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
                <Col span="3" style="margin-left: 8px">
                  <FormItem prop="LinkTel2">
                    <Input
                      type="text"
                      v-model="formInline.LinkTel2"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
                <Col span="5" style="margin-left: 8px">
                  <FormItem prop="LinkTel3">
                    <Input
                      type="text"
                      v-model="formInline.LinkTel3"
                      :disabled="catalogueDownInfo && editStatus ? true : false"
                    />
                  </FormItem>
                </Col>
                <Col span="8">
                  <p style="color: #ccc">示例：+86-10-84666617</p>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="传真：" style="margin-bottom: 0" v-if="false">
              <Row :gutter="8" type="flex">
                <Col span="13">
                  <FormItem :label-width="75" class="no-label">
                    <Row :gutter="8" type="flex">
                      <Col span="6">
                        <FormItem style="margin-bottom: 0">
                          <Input
                            type="text"
                            v-model="formInline.LinkFax1"
                            :disabled="
                              catalogueDownInfo && editStatus ? true : false
                            "
                          />
                        </FormItem>
                      </Col>
                      <Col span="6">
                        <FormItem style="margin-bottom: 0">
                          <Input
                            type="text"
                            v-model="formInline.LinkFax2"
                            :disabled="
                              catalogueDownInfo && editStatus ? true : false
                            "
                          />
                        </FormItem>
                      </Col>
                      <Col span="12">
                        <FormItem style="margin-bottom: 0">
                          <Input
                            type="text"
                            v-model="formInline.LinkFax3"
                            :disabled="
                              catalogueDownInfo && editStatus ? true : false
                            "
                          />
                        </FormItem>
                      </Col>
                    </Row>
                  </FormItem>
                </Col>
              </Row>
            </FormItem>

            <FormItem
              label="会刊中文简介："
              class="intTextarea"
              prop="introduction"
              style="margin-bottom: 0"
            >
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="100"
                v-model="formInline.introduction"
                placeholder="请输入会刊中文简介"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
              <p style="text-align: right; color: #bfbfbf">
                {{
                  formInline.introduction ? formInline.introduction.length : 0
                }}/100字
              </p>
            </FormItem>
            <FormItem
              label="会刊英文简介："
              class="intTextarea"
              prop="enIntroduction"
              style="margin-bottom: 0"
            >
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="350"
                v-model="formInline.enIntroduction"
                placeholder="请输入会刊英文简介"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
              <p style="text-align: right; color: #bfbfbf">
                {{
                  formInline.enIntroduction
                    ? formInline.enIntroduction.length
                    : 0
                }}/350字
              </p>
            </FormItem>
            <FormItem
              label="中文公司简介及产品简介："
              class="intTextarea"
              prop="profile"
              style="margin-bottom: 0"
              v-if="false"
            >
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                v-model="formInline.profile"
                placeholder="请输入中文公司简介及产品简介"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
              <p style="text-align: right; color: #bfbfbf">
                {{ formInline.profile ? formInline.profile.length : 0 }}/500字
              </p>
            </FormItem>
            <FormItem
              label="英文公司简介及产品简介："
              class="intTextarea"
              prop="enProfile"
              v-if="false"
            >
              <Input
                type="textarea"
                :rows="4"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                v-model="formInline.enProfile"
                placeholder="请输入英文公司简介及产品简介"
                :disabled="catalogueDownInfo && editStatus ? true : false"
              />
              <p style="text-align: right; color: #bfbfbf">
                {{
                  formInline.enProfile ? formInline.enProfile.length : 0
                }}/500字
              </p>
            </FormItem>
            <FormItem v-if="!editStatus" style="padding-top: 20px">
              <Button
                type="primary"
                size="large"
                @click="handleSubmit('formInline')"
                style="width: 154px"
                :loading="loading"
                >保存</Button
              >
            </FormItem>
          </Form>
        </div>
        <div>
          <img
            :src="wxcodeUrl"
            alt=""
            style="width: 200px; height: 200px; margin-left: 100px"
          />
          <div style="display: flex; justify-content: center">
            <Button
              @click="downs()"
              style="margin-left: 100px; margin-top: 20px"
              >下载二维码</Button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />

    <!-- 图片查看 -->
    <iModal title="图片查看" cancel-text v-model="visible">
      <div style="text-align: center">
        <img :src="imgName" v-if="visible && imgName" style="max-width: 100%" />
        <img src="@assets/img/empty.png" v-else />
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
  name: "exhibition-info-catalogue",
  data() {
    const that = this;
    const logoReg = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传Logo"));
      }
    };
    const provinceReg = (rule, value, callback) => {
      if (that.formInline.country !== "中国") {
        callback();
      }
      if (
        that.provinceArr &&
        that.provinceArr.length &&
        !that.formInline.province
      ) {
        callback(new Error("请选择省份"));
      } else {
        callback();
      }
    };
    const tellReg = (rule, value, callback) => {
      if (!value) {
        callback(new Error("必填"));
      } else {
        callback();
      }
    };
    const cityReg = (rule, value, callback) => {
      if (that.formInline.country !== "中国") {
        callback();
      }
      if (that.citiesArr && that.citiesArr.length && !that.formInline.city) {
        callback(new Error("请选择城市"));
      } else {
        callback();
      }
    };
    const phoneReg = (rule, value, callback) => {
      if (!value) {
        callback("请输入手机号码");
      } else if (
        /^[1][0-9]{10}$/.test(value) ||
        value.length == 8 ||
        value.length == 12
      ) {
        callback();
      } else {
        callback("请输入正确的手机号码");
      }
    };
    return {
        spinShow: false,

      catalogueInfoIsHave: false, // 会刊信息是否存在
      // staffArr: [
      //   {
      //     value: "10人以下",
      //     label: "10人以下"
      //   },
      //   {
      //     value: "10~50人",
      //     label: "10~50人"
      //   },
      //   {
      //     value: "50~100人",
      //     label: "50~100人"
      //   },
      //   {
      //     value: "100~500人",
      //     label: "100~500人"
      //   },
      //   {
      //     value: "500~1000人",
      //     label: "500~1000人"
      //   },
      //   {
      //     value: "1000~5000人",
      //     label: "1000~5000人"
      //   },
      //   {
      //     value: "5000人以上",
      //     label: "5000人以上"
      //   }
      // ],
      formInline: {
        name: "", // 公司名称
        exHall: "", // 展位号，修改时不用提交
        enName: "", // 英文名
        country: "",
        province: "",
        city: "",
        address: "", // 地址
        mail: "", // 邮政编码
        enAddress: "", //英文地址
        // type: "", // 企业类型
        // staff: "", // 人员规模
        // sales: "", // 年销售额
        url: "", // 公司网址
        email: "", // 公司邮箱
        LinkFirstName: "", // 联系人姓氏
        LinkLastName: "", // 联系人名字
        LinkMob: "", // 联系人手机号码
        LinkTel1: "",
        LinkTel2: "",
        LinkTel3: "",
        LinkFax1: "",
        LinkFax2: "",
        LinkFax3: "",
        introduction: "", // 会刊中文简介
        enIntroduction: "", // 会刊英文简介
        profile: "", // 中文公司简介及产品简介
        enProfile: "", // 英文公司简介及产品简介
      },
      ruleInline: {
        enName: [
          { required: true, message: "请输入公司英文名", trigger: "blur" },
        ],
        country: [
          { required: true, message: "国家/地区不能为空", trigger: "change" },
        ],
        province: [
          { required: true, validator: provinceReg, trigger: "change" },
        ],
        city: [{ required: true, validator: cityReg, trigger: "change" }],
        address: [
          { required: true, message: "填写街道楼牌号", trigger: "blur" },
        ],
        mail: [{ required: true, message: "请输入邮政编码", trigger: "blur" }],
        enAddress: [
          { required: true, message: "请输入英文地址", trigger: "blur" },
        ],
        // type: [
        //   { required: true, message: "请选择企业类型", trigger: "change" }
        // ],
        // staff: [{ required: true, message: "请输入人员规模", trigger: "blur" }],
        // sales: [{ required: true, message: "请输入年销售额", trigger: "blur" }],
        email: validator.email,
        LinkFirstName: [{ required: true, message: "姓氏", trigger: "blur" }],
        LinkLastName: [{ required: true, message: "名字", trigger: "blur" }],
        LinkMob: [
          { required: true, message: "请输入联系人手机", trigger: "blur" },
          { required: true, validator: phoneReg, trigger: "blur" },
        ],
        LinkTel1: [{ required: true, validator: tellReg, trigger: "blur" }],
        LinkTel2: [{ required: true, validator: tellReg, trigger: "blur" }],
        LinkTel3: [{ required: true, validator: tellReg, trigger: "blur" }],
        introduction: [
          { required: true, message: "请输入会刊中文简介", trigger: "blur" },
        ],
        enIntroduction: [
          { required: true, message: "请输入会刊英文简介", trigger: "blur" },
        ],
        // profile: [
        //   {
        //     required: true,
        //     message: "请输入中文公司简介及产品简介",
        //     trigger: "blur"
        //   }
        // ],
        // enProfile: [
        //   {
        //     required: true,
        //     message: "请输入英文公司简介及产品简介",
        //     trigger: "blur"
        //   }
        // ]
        // logo: [{ required: true, validator: logoReg, trigger: "blur" }]
      },
      countryList: [],
      provinceArr: [],
      citiesArr: [],
      // exTypeList: [],
      uploadList: [],
      defaultList: [],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      imgName: "",
      visible: false,
      catalogueInfo: null, // 会刊信息
      catalogueDownInfo: null, // 会刊信息提交的修改内容
      editStatus: false,
      wxcodeUrl: "", //小程序二维码
      loading: false,
    };
  },
  components: {
    imgUpload,
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
    }),
    exhibitionId() {
      return this.exhibition.id;
    },
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 会刊提交";
    this.init();
  },
  methods: {
    ...mapActions({
      getCountryList: "exhibitionModule/getCountryList",
      getCityList: "exhibitionModule/getCityList",
      getCityByParentId: "exhibitionModule/getCityByParentId",
      getCatalogueByJoinId: "exhibitionModule/getCatalogueByJoinId",
      getCatalogueType: "exhibitionModule/getCatalogueType",
      submitCatalogue: "exhibitionModule/submitCatalogue",
      submitCatalogueDown: "exhibitionModule/submitCatalogueDown",
      getCatalogueDown: "exhibitionModule/getCatalogueDown",
      getCatalogueCeShi: "exhibitionModule/getCatalogueCeShi",
      getWeAppCode: "exhibitionModule/getWeAppCode",
      getFile: "exhibitionModule/getFile",
      downFile: "exhibitionModule/downFile",
    }),
    async downs() {
      let opt = {
        targetType: 0,
        targetId: this.joinInfo.id,
        scene: this.company.id + " " + this.exhibitionId,
      };
      let data = await this.downFile(opt);
      let imgData = data; //填写你的base64
    },

    async init() {
        this.spinShow = true;
      //获取小程序码
      let opt = {
        targetType: 0,
        targetId: this.joinInfo.joinId,
        scene: this.company.id + " " + this.exhibitionId,
      };
      let data = await this.getWeAppCode(opt);
      if (data) {
        this.wxcodeUrl = data.path;
      }

      this.formInline.exHall = "";
      let countryList = await this.getCountryList();
      console.log(countryList, "11111111111");
      if (countryList && countryList.length > 0) {
        this.countryList = countryList;
      }
      this.formInline.name = this.company.name;
      if (
        this.joinInfo &&
        this.joinInfo.boothInfo &&
        this.joinInfo.boothInfo.length
      ) {
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object String]"
        ) {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object Object]"
        ) {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
          if (this.joinInfo.boothInfo.Hall) {
            this.formInline.exHall =
              this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
          } else {
            this.formInline.exHall = this.joinInfo.boothInfo.Code;
          }
        }
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object Array]"
        ) {
          let boothInfo = this.joinInfo.boothInfo;
          for (let i = 0; i < boothInfo.length; i++) {
            if (boothInfo.length > 1) {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Hall + "、";
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Code + "、";
              }
            } else {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code;
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Hall;
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Code;
              }
            }
          }
        }
        // this.formInline.exHall = boothInfo.Hall + '-' + boothInfo.Code;
      }
      // 获取会刊修改记录
      let result = await this.getCatalogueDown(this.joinInfo.joinId);
      if (result) {
        this.catalogueDownInfo = result;
        if (
          this.catalogueDownInfo.syncStatus === 2 &&
          this.catalogueDownInfo.status === 1
        ) {
          this.editStatus = false;
        } else {
          this.editStatus = true;
        }
      }
      // 测试
      // let hh = await this.getCatalogueCeShi();
      // if (hh) {
      //   this.catalogueInfo = hh;
      // }

      // 根据joinId获取会刊信息
      // 如果返回信息存在，则保存时调用修改接口，若返回信息不存在，保存时调用新增接口
      let result2 = await this.getCatalogueByJoinId(this.joinInfo.joinId);
      console.log(result2, "会刊信息");
      if (result2) {
        this.catalogueInfoIsHave = true;
        this.catalogueInfo = result2;
        console.log("catalogueInfo：", this.catalogueInfo);
      }
      // let res = await this.getCatalogueType();
      // if (res) {
      //   this.exTypeList = res;
      // }
      if (this.catalogueInfo) {
        this.formInline.enName = this.catalogueInfo.compNameEn;
        this.formInline.country = this.catalogueInfo.area;
        this.formInline.province = this.catalogueInfo.province;
        this.formInline.city = this.catalogueInfo.city;
        if (this.formInline.country === "中国") {
          // let provinceList = await this.getCityList();
          let provinceList = await this.getCityByParentId(
            "2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD"
          );
          if (provinceList && provinceList.length > 0) {
            // this.provinceArr = provinceList[0].list;
            this.provinceArr = provinceList;
            let provinceId = "";
            this.provinceArr.map((c) => {
              if (c.shortname === this.formInline.province) {
                provinceId = c.id;
              }
            });
            if (provinceId) {
              let cityList = await this.getCityByParentId(provinceId);
              if (cityList && cityList.length > 0) {
                this.citiesArr = cityList;
              }
            }
          }
        }
        // for (var i = 0; i < this.provinceArr.length; i++) {
        //   if (this.catalogueInfo.province == this.provinceArr[i].shortname) {
        //     this.citiesArr = this.provinceArr[i].list;
        //   }
        // }
        this.formInline.address = this.catalogueInfo.address;
        this.formInline.mail = this.catalogueInfo.postcode;
        this.formInline.enAddress = this.catalogueInfo.addressEn;
        // this.formInline.type = this.catalogueInfo.industry;
        // this.formInline.staff = this.catalogueInfo.scale;
        // this.formInline.sales = this.catalogueInfo.annualSales;
        this.formInline.url = this.catalogueInfo.website;
        this.formInline.email = this.catalogueInfo.email;
        this.formInline.LinkFirstName = this.catalogueInfo.linkFirstName;
        this.formInline.LinkLastName = this.catalogueInfo.linkLastName;
        this.formInline.LinkMob = this.catalogueInfo.linkMob;

        let telArr = [];
        if (this.catalogueInfo.linkTel) {
          telArr = this.catalogueInfo.linkTel.split("-");
        }
        if (telArr[0]) {
          this.formInline.LinkTel1 = telArr[0];
        }
        if (telArr[1]) {
          this.formInline.LinkTel2 = telArr[1];
        }
        if (telArr[2]) {
          this.formInline.LinkTel3 = telArr[2];
        }
        // let faxArr = this.catalogueInfo.linkFax.split("-");
        // if (faxArr[0]) {
        //   this.formInline.LinkFax1 = faxArr[0];
        // }
        // if (faxArr[1]) {
        //   this.formInline.LinkFax2 = faxArr[1];
        // }
        // if (faxArr[2]) {
        //   this.formInline.LinkFax3 = faxArr[2];
        // }
        this.formInline.introduction = this.catalogueInfo.introduction;
        this.formInline.enIntroduction = this.catalogueInfo.introductionEn;
        this.formInline.profile = this.catalogueInfo.profile;
        this.formInline.enProfile = this.catalogueInfo.profileEn;
        if (this.catalogueInfo.logo) {
          let uploadList = [
            {
              percentage: 100,
              status: "finished",
              url: this.catalogueInfo.logo,
            },
          ];
          this.uploadList = uploadList;
        }
      }
        this.spinShow = false;
    },
    async handleSubmit(name) {
      let txt = "";
      let valid = await this.validForm(name);
      this.$refs[name].fields.forEach((c) => {
        if (txt) return;
        if (c.validateState === "error") {
          txt = c.validateMessage;
        }
      });
      if (!valid && txt) {
        this.$Message.warning(txt);
      }
      if (!valid) {
        return;
      }
      this.loading = true;
      let Logo = "";
      if (this.uploadList && this.uploadList.length) {
        Logo = this.uploadList[0].url;
      }

      let LinkTel = "";
      if (this.formInline.LinkTel2 && this.formInline.LinkTel3) {
        LinkTel =
          this.formInline.LinkTel1 +
          "-" +
          this.formInline.LinkTel2 +
          "-" +
          this.formInline.LinkTel3;
      }
      if (!this.formInline.LinkTel2) {
        LinkTel = this.formInline.LinkTel1 + "-" + this.formInline.LinkTel3;
      }
      if (!this.formInline.LinkTel3) {
        LinkTel = this.formInline.LinkTel1 + "-" + this.formInline.LinkTel2;
      }
      if (!this.formInline.LinkTel2 && !this.formInline.LinkTel3) {
        LinkTel = String(this.formInline.LinkTel1);
      }

      // let LinkFax = "";
      // if (this.formInline.LinkFax2 && this.formInline.LinkFax3) {
      //   LinkFax =
      //     this.formInline.LinkFax1 +
      //     "-" +
      //     this.formInline.LinkFax2 +
      //     "-" +
      //     this.formInline.LinkFax3;
      // }
      // if (!this.formInline.LinkFax2) {
      //   LinkFax = this.formInline.LinkFax1 + "-" + this.formInline.LinkFax3;
      // }
      // if (!this.formInline.LinkFax3) {
      //   LinkFax = this.formInline.LinkFax1 + "-" + this.formInline.LinkFax2;
      // }
      // if (!this.formInline.LinkFax2 && !this.formInline.LinkFax3) {
      //   LinkFax = String(this.formInline.LinkFax1);
      // }

      let req = {
        JoinId: this.joinInfo.joinId,
        CompName: this.formInline.name,
        CompNameEn: this.formInline.enName,
        Logo: Logo,
        Area: this.formInline.country,
        Province: this.formInline.province,
        City: this.formInline.city,
        Address: this.formInline.address,
        Postcode: this.formInline.mail,
        AddressEn: this.formInline.enAddress,
        // Industry: this.formInline.type,
        // Scale: this.formInline.staff,
        // AnnualSales: this.formInline.sales,
        Website: this.formInline.url,
        Email: this.formInline.email,
        LinkFirstName: this.formInline.LinkFirstName,
        LinkLastName: this.formInline.LinkLastName,
        LinkMob: this.formInline.LinkMob,
        LinkTel: LinkTel,
        // LinkFax: LinkFax,
        Introduction: this.formInline.introduction,
        IntroductionEn: this.formInline.enIntroduction,
        // Profile: this.formInline.profile,
        // ProfileEn: this.formInline.enProfile
      };

      if (this.catalogueInfoIsHave) {
        let opt1 = {
          Id: this.catalogueInfo.id,
          ExhibitonId: this.exhibitionId,
          JoinId: this.joinInfo.joinId,
          CommandId: 2, // "CommandId说明":"1：新增，2：修改，3：删除",
          SetValues: req,
        };
        let result = await this.submitCatalogueDown(opt1);
        this.loading = false;
        if (result && result.successed) {
          this.$Message.success("保存成功，请等待审核");
          this.init();
        } else {
          if (result.errors && result.errors[0]) {
            this.$Message.warning(result.errors[0].description);
          } else {
            this.$Message.warning(`保存失败，请重试`);
          }
        }
      } else {
        let opt2 = {
          ExhibitonId: this.exhibitionId,
          JoinId: this.joinInfo.joinId,
          CommandId: 1, // "CommandId说明":"1：新增，2：修改，3：删除",
          SetValues: req,
        };
        let bool = await this.submitCatalogue(opt2);
        if (bool && bool.successed) {
          this.$Message.success("保存成功，请等待审核");
          this.init();
        } else {
          if (bool.errors && bool.errors[0]) {
            this.$Message.warning(bool.errors[0].description);
          } else {
            this.$Message.warning(`保存失败，请重试`);
          }
        }
      }
    },
    copyInfo() {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", this.formInline.name);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$Message.success("复制成功");
      }
      document.body.removeChild(input);
    },
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList.push({
            percentage: 100,
            status: "finished",
            url: item,
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    selectType() {
      this.uploadList = [];
      this.defaultList = [];
      this.$refs.upload.fileList = [];
      this.uploadChooseShowed = true;
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    async changeCountry(val) {
      if (val === "中国") {
        // let provinceList = await this.getCityList();
        let provinceList = await this.getCityByParentId(
          "2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD"
        );
        if (provinceList && provinceList.length > 0) {
          // this.provinceArr = provinceList[0].list;
          this.provinceArr = provinceList;
        }
      } else {
        this.provinceArr = [];
        this.citiesArr = [];
        this.formInline.province = "";
        this.formInline.city = "";
      }
    },
    changeProvince(val) {
      // for (var i = 0; i < this.provinceArr.length; i++) {
      //   if (val == this.provinceArr[i].shortname) {
      //     this.citiesArr = this.provinceArr[i].list;
      //   }
      // }
    },
    async changeProvinceValue(item) {
      let cityList = await this.getCityByParentId(item.id);
      if (cityList && cityList.length > 0) {
        this.citiesArr = cityList;
      } else {
        this.formInline.city = "";
        this.citiesArr = [];
      }
    },
    changeCountryValue(val) {
      this.formInline.LinkTel1 = val.code;
      // this.formInline.LinkFax1 = val.code;
    },
    changeCity(val) {
      this.formInline.LinkTel2 = val.citycode;
      // this.formInline.LinkFax2 = val.citycode;
    },
  },
};
</script>

<style lang="scss">
.intTextarea {
  .ivu-form-item-error-tip {
    top: 75%;
  }
}
.no-label {
  .ivu-form-item-label:before {
    opacity: 0 !important;
  }
}
</style>
<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1400px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
    .catalogue-tip {
      color: #ff0000;
      padding: 0 0 5px 200px;
      .txt {
        padding-left: 10px;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
    &-l {
      width: 50%;
      min-width: 700px;
    }
    &-r {
      display: flex;
      // min-width: 700px;
      .logo-example {
        display: flex;
        &-box {
          display: flex;
          flex-wrap: wrap;
          flex: 1;
        }
        &-item {
          display: flex;
          width: 100%;
          p {
            font-size: 12px;
            color: #808080;
            padding-left: 10px;
          }
          &.z-large-s {
            img {
              width: 40px;
              height: 40px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 40px;
            }
          }
          &.z-large-m {
            img {
              width: 30px;
              height: 30px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 30px;
            }
          }
          &.z-large-l {
            img {
              width: 20px;
              height: 20px;
              border: 1px solid #bfbfbf;
            }
            p {
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .mask {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
